import _ViewController from '../ViewController'

import createControl from './createControls'

const newAddFilterButtons = (categories, data, map) => {
  const filterButtonsList = []

  const menuButtons = categories.filter((el) => {
    return el.type === 'menu'
  })

  const filterButtons = categories.filter((el) => {
    return el.type === 'filter'
  })

  // create menu container
  const menuContainer = document.createElement('div')
  menuContainer.setAttribute('class', 'filterButtonsContainer')
  menuContainer.index = 1
  menuContainer.addEventListener(
    'click',
    _ViewController.onMenuContainerClick
  )

  // get each menu button and create a control-element
  menuButtons
    .map((button) => {
      const menuButton = {}
      menuButton.element = createControl(
        button,
        'button hidden'
        )
      menuButton.categoryNumber = button.parent
      return menuButton
    })

    // take the menu buttons array
    // attach the secondary buttons to corresponding button
    .forEach((menuButton) => {
      // create parent-element for the filter buttons
      // corresponding to the current menu button
      const filterParent = document.createElement('ul')
      filterParent.setAttribute('class', 'secondary-parent')

      // create the filter buttons
      // corresponding to the current menu button
      filterButtons.forEach((button) => {
        if (button.parent === menuButton.categoryNumber) {
          const filterButton = createControl(
            button,
            'secondary-button'
            )
          // push the menu button for reference
          filterButtonsList.push(filterButton)
          // append filter buttons to container element
          filterParent.appendChild(filterButton)
        }
      })

      // append filter parent to menu button
      menuButton.element.appendChild(filterParent)

      // append menu button to menu container
      menuContainer.appendChild(menuButton.element)
    })

  // add menu container to google api control array
  map.controls[google.maps.ControlPosition.LEFT_CENTER].push(
    menuContainer
  )
  return filterButtonsList
}

export default newAddFilterButtons



// WEBPACK FOOTER //
// ./src/mapSetup/addMenu.js